module.exports = "/img/item-1.14a7d9d0.png";